export const GridWrapper: React.FC = ({ children }) => {
  return (
    <div className="grid gap-0.5 grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
      <>{children}</>
    </div>
  );
};
